/* src/app/private/components/leads/move-to-registration/move-to-registration.component.scss */
/*# sourceMappingURL=move-to-registration.component.css.map */
